export default {
  teamsTree: null,
  teams: null,
  team: null
};
